import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames/bind';
import CartItem from '~/components/legacy/CartItem.jsx';
import { parseReactProps } from '~/components/legacy/reactProps.js';
import legacyEventHub, { cartItemsFromEvent, cartPayloadFromEvent } from '~/modules/legacyRuntime.js';

const CHECKOUT_HISTORY_CART_REFRESH_FLAG = 'checkout:refresh-cart-on-history-back';

class Cart extends Component {

  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
    this.closeCart = this.closeCart.bind(this);
    this.createPortalRoot = this.createPortalRoot.bind(this);
    this.destroyPortalRoot = this.destroyPortalRoot.bind(this);
    this.renderDrawerMarkup = this.renderDrawerMarkup.bind(this);
    this.hasIncompleteProjectLicenseSelection = this.hasIncompleteProjectLicenseSelection.bind(this);
    this.hasIncompleteEventTrackLicenseSelection = this.hasIncompleteEventTrackLicenseSelection.bind(this);
    this.checkoutHintCopy = this.checkoutHintCopy.bind(this);
    this.handlePageShow = this.handlePageShow.bind(this);
    this.reloadPage = this.reloadPage.bind(this);

    this.state = {
      opened: false,
      currencySymbol: '€',
      recentlyUpdated : false,
      data : this.props.data
     };
  }

  // getInitialState: function() {
  //   return {
  //       opened: false,
  //       currencySymbol: '€',
  //       recentlyUpdated : false,
  //       data : this.props.data
  //   };
  // },

  // getDefaultProps : function() {
  //     return {
  //         data : [],
  //         subscribedUsageLicenseTypes: [],
  //         flatrateDownloadsToday: 0,
  //         flatrateDownloadLimit: 0,
  //         usage_license_types: [],
  //         i18n : {
  //             free: 'for free',
  //             checkout_now: 'Checkout now',
  //             shopping_cart: 'Shopping cart'
  //         }
  //     }
  // },

  componentDidMount() {
      this.createPortalRoot();
      window.addEventListener('pageshow', this.handlePageShow);

      if (this.onCheckoutPage()) {
        this.storeCheckoutHistoryRefreshFlag();
      }

      legacyEventHub.on('updateCart', function(data) {
          let that = this;
          let payload = cartPayloadFromEvent(data);
          let items = cartItemsFromEvent(data);

          if (items.length === this.state.data.length - 1) {
            // item was removed, we omit animations
            that.setState({data: items})
          } else {
            setTimeout(function() {
              that.setState({data: items, 'recentlyUpdated': true});
            }, 850)

            setTimeout(function() {
                that.setState({'recentlyUpdated': false});
            }, 2000);
          }

          if (items.length === 0) {
            this.setState({'opened': false});
          }

      }.bind(this));

      legacyEventHub.on('menuFavoritesOpened', function() {
          this.setState({'opened': false});
      }.bind(this));

      legacyEventHub.on('closePopupMenus', function() {
        this.setState({'opened': false});
      }.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener('pageshow', this.handlePageShow);
    this.destroyPortalRoot();
  }

  onCheckoutPage() {
    if (typeof document === 'undefined') {
      return false;
    }

    return document.body?.dataset?.controllerPath === 'c/checkouts';
  }

  safeSessionStorage() {
    if (typeof window === 'undefined') {
      return null;
    }

    try {
      return window.sessionStorage || null;
    } catch (_error) {
      return null;
    }
  }

  storeCheckoutHistoryRefreshFlag() {
    const storage = this.safeSessionStorage();
    if (!storage) {
      return;
    }

    try {
      storage.setItem(CHECKOUT_HISTORY_CART_REFRESH_FLAG, '1');
    } catch (_error) {
      // Safari can block sessionStorage access for bfcache restores or strict privacy settings.
    }
  }

  clearCheckoutHistoryRefreshFlag() {
    const storage = this.safeSessionStorage();
    if (!storage) {
      return;
    }

    try {
      storage.removeItem(CHECKOUT_HISTORY_CART_REFRESH_FLAG);
    } catch (_error) {
      // Ignore storage cleanup failures; they only affect the refresh guard.
    }
  }

  checkoutHistoryRefreshFlag() {
    const storage = this.safeSessionStorage();
    if (!storage) {
      return null;
    }

    try {
      return storage.getItem(CHECKOUT_HISTORY_CART_REFRESH_FLAG);
    } catch (_error) {
      return null;
    }
  }

  shouldRefreshForHistoryNavigation(event) {
    if (typeof window === 'undefined') {
      return false;
    }

    if (event?.persisted) {
      return true;
    }

    if (typeof window.performance?.getEntriesByType === 'function') {
      const navigationEntries = window.performance.getEntriesByType('navigation');
      if (Array.isArray(navigationEntries) && navigationEntries[0]?.type === 'back_forward') {
        return true;
      }
    }

    if (window.performance?.navigation) {
      return window.performance.navigation.type === 2;
    }

    return false;
  }

  handlePageShow(event) {
    if (this.onCheckoutPage()) {
      this.storeCheckoutHistoryRefreshFlag();
      return;
    }

    if (this.checkoutHistoryRefreshFlag() !== '1') {
      return;
    }

    if (!this.shouldRefreshForHistoryNavigation(event)) {
      return;
    }

    this.clearCheckoutHistoryRefreshFlag();
    this.reloadPage();
  }

  reloadPage() {
    window.location.reload();
  }

  createPortalRoot() {
    if (typeof document === 'undefined' || this.portalRoot) {
      return;
    }

    this.portalRoot = document.createElement('div');
    this.portalRoot.className = 'cart__portal';
    document.body.appendChild(this.portalRoot);
  }

  destroyPortalRoot() {
    if (!this.portalRoot) {
      return;
    }

    if (this.portalRoot.parentNode) {
      this.portalRoot.parentNode.removeChild(this.portalRoot);
    }

    this.portalRoot = null;
  }

  handleClick() {
    if (!this.state.opened) {
      legacyEventHub.trigger('menuCartOpened');
    }

    this.setState({opened: !this.state.opened});
  }

  closeCart() {
    this.setState({opened: false});
  }

  normalizedSubscribedUsageLicenseTypeIds() {
      return (this.props.subscribedUsageLicenseTypes || []).map(function(id) {
          return Number(id);
      }).filter(function(id) {
          return !Number.isNaN(id);
      });
  }

  includedInSubscription(usageLicenseTypeId) {
      let normalizedUsageLicenseTypeId = Number(usageLicenseTypeId);

      if (Number.isNaN(normalizedUsageLicenseTypeId)) {
          return false;
      }

      return this.normalizedSubscribedUsageLicenseTypeIds().includes(normalizedUsageLicenseTypeId);
  }

  cartItemIncludedInSubscription(cartItem) {
      if (cartItem && cartItem.flatrate_access === true) {
          return true;
      }

      return this.includedInSubscription(cartItem.usage_license_type_id);
  }

  cartIsFree() {
      let isFree = false;

      if (this.state.data) {
          isFree = true;

          this.state.data.forEach(function(cartItem) {
              if (!this.cartItemIncludedInSubscription(cartItem)) {
                  isFree = false;
              }
          }.bind(this))
      }

      return isFree;
  }

  getUsageLicenseTypeById(usageLicenseTypeId) {
      let match,
          normalizedUsageLicenseTypeId = Number(usageLicenseTypeId);

      this.props.usage_license_types.forEach(function(usageLicenseType) {
          if (Number(usageLicenseType.id) === normalizedUsageLicenseTypeId) {
              match = usageLicenseType;
          }
      });

      return match;
  }

  getUsageLicenseTypeForCartItem(cartItem) {
      let usageLicenseType = this.getUsageLicenseTypeById(cartItem.usage_license_type_id);

      if (usageLicenseType) {
          return {
              ...usageLicenseType,
              name: cartItem.usage_license_type_name || usageLicenseType.name,
              formatted_country_gross_price: cartItem.usage_license_type_formatted_country_gross_price || usageLicenseType.formatted_country_gross_price,
              formatted_country_discount_gross_price: cartItem.usage_license_type_formatted_country_discount_gross_price || usageLicenseType.formatted_country_discount_gross_price
          };
      }

      if (!cartItem.usage_license_type_id) {
          return null;
      }

      return {
          id: cartItem.usage_license_type_id,
          name: cartItem.usage_license_type_name,
          formatted_country_gross_price: cartItem.usage_license_type_formatted_country_gross_price,
          formatted_country_discount_gross_price: cartItem.usage_license_type_formatted_country_discount_gross_price
      };
  }

  hasIncompleteProjectLicenseSelection() {
    return (this.state.data || []).some(function(cartItem) {
      const optionKeys = Array.isArray(cartItem.project_license_option_keys) ? cartItem.project_license_option_keys : [];

      return cartItem.project_license_flow === 'v2' &&
        Boolean(cartItem.track_id) &&
        Boolean(cartItem.usage_license_type_id) &&
        !cartItem.customer_project_license_preset_id &&
        optionKeys.length === 0;
    });
  }

  hasIncompleteEventTrackLicenseSelection() {
    return (this.state.data || []).some(function(cartItem) {
      return cartItem.event_track_license === true && cartItem.event_track_price_final !== true;
    });
  }

  checkoutHintCopy() {
    if (this.hasIncompleteEventTrackLicenseSelection()) {
      return this.props.locale === 'de' ?
        'Eventdaten wie Besucherzahl, Eventtyp, Laufzeit, Locations und Videonutzung legen Sie im nächsten Schritt einmal für alle ausgewählten Titel fest.' :
        'In the next step, define audience, event type, duration, locations, and video use once for all selected tracks.';
    }

    if (!this.hasIncompleteProjectLicenseSelection()) {
      return null;
    }

    return this.props.locale === 'de' ?
      'Basislizenz gewählt. Lizenzkonfiguration folgt im nächsten Schritt.' :
      'Base license selected. License configuration follows in the next step.';
  }

  renderDrawerMarkup(cartItems, submitButton, limitHeading, checkoutHint) {
    const keepShoppingLabel = this.props.locale === 'de' ? 'Weiter einkaufen' : 'Keep shopping';
    const closeLabel = this.props.locale === 'de' ? 'Warenkorb schließen' : 'Close cart';
    const emptyLabel = this.props.locale === 'de' ? 'Ihr Warenkorb ist noch leer.' : 'Your cart is empty.';

    return (
      <div className='cart__drawer-shell'>
        <div className='cart__backdrop' onClick={this.closeCart}></div>
        <div className='cart__list'>
          <div className='cart__drawer-header'>
            <div className='cart__list-heading'>{this.props.i18n.shopping_cart}</div>
            <button type='button' className='cart__drawer-close' onClick={this.closeCart} aria-label={closeLabel}>
              <i className='fa fa-times'></i>
            </button>
          </div>
          <div className='cart__drawer-body'>
            {limitHeading ? <div className='cart__drawer-meta'>{limitHeading}</div> : null}
            {cartItems.length > 0 ? cartItems : <div className='cart__empty-copy'>{emptyLabel}</div>}
          </div>
          <div className='cart__drawer-footer'>
            <div className='cart-action'>
              {checkoutHint ? <div className='cart__checkout-hint'>{checkoutHint}</div> : null}
              {submitButton}
            </div>
            <button type='button' className='cart__keep-shopping' onClick={this.closeCart}>
              {keepShoppingLabel}
            </button>
          </div>
        </div>
      </div>
    );
  }

  render() {
    let cartItems = [],
        submitButton,
        classes,
        limitHeading;

    if (this.state.data) {
        cartItems = this.state.data.map(function (cartItem, index) {
          return (
            <CartItem
              id={cartItem.track_id}
              locale={this.props.locale}
              exposure_pack_id={cartItem.exposure_pack_id}
              sound_effect_id={cartItem.sound_effect_id}
              usage_license_type_id={cartItem.usage_license_type_id}
              title={cartItem.title}
              track_image_markup={cartItem.track_image}
              includedInSubscription={this.cartItemIncludedInSubscription(cartItem)}
              eventTrackLicense={cartItem.event_track_license === true}
              eventTrackPriceFinal={cartItem.event_track_price_final === true}
              usageLicenseType={this.getUsageLicenseTypeForCartItem(cartItem)}
              usageLicenseTypeId={cartItem.usage_license_type_id}
              projectLicenseFlow={cartItem.project_license_flow}
              projectLicenseOptionKeys={cartItem.project_license_option_keys}
              customerProjectLicensePresetId={cartItem.customer_project_license_preset_id}
              customerEventLicensePresetId={cartItem.customer_event_license_preset_id}
              projectLicensePresetName={cartItem.project_license_preset_name || cartItem.event_license_preset_name}
              key={"cartItem-" + cartItem.track_id + '-' + cartItem.usage_license_type_id + '-' + (cartItem.customer_project_license_preset_id || cartItem.customer_event_license_preset_id || 'none') + '-' + (Array.isArray(cartItem.project_license_option_keys) ? cartItem.project_license_option_keys.join('-') : 'no-options') + '-' + index}
              usage_license_types={this.props.usage_license_types}
              free={cartItem.free}
              discount={cartItem.discount}
              flatrate_access={this.props.flatrate_access}
              i18n={this.props.i18n} />
          );
        }.bind(this));
    }

    classes = classNames({
      'cart': true,
      'cart--filled' : cartItems.length !== 0,
      'is-open' : this.state.opened,
      'is-closed' : !this.state.opened,
      'is-empty' : cartItems.length === 0,
      'is-recently-updated' : this.state.recentlyUpdated
    });

    if (this.props.subscribedUsageLicenseTypes.length > 0) {
      limitHeading = (
        <div className='cart__usage-limit'>
          {this.props.locale === 'de' ? 'Heutige Abo-Downloads:' : 'Subscription downloads today:'} ({this.props.flatrateDownloadsToday} / {this.props.flatrateDownloadLimit})
        </div>
      );
    }

    submitButton = (function() {
      let buttonText = this.props.i18n.checkout_now;

      if (this.cartIsFree()) {
        buttonText = this.props.locale === 'de' ? 'Zum Download' : 'Proceed to download';
      }

      return (
        <a className='button button--secondary button--full' href='/c/checkouts/new' title={buttonText}>{buttonText}</a>
        );
      }.bind(this))();
    const checkoutHint = this.checkoutHintCopy();
    const drawerMarkup = this.state.opened && this.portalRoot ? ReactDOM.createPortal(
      this.renderDrawerMarkup(cartItems, submitButton, limitHeading, checkoutHint),
      this.portalRoot
    ) : null;

    return (
      <div className={classes}>
        <div className='cart__status clearfix' onClick={cartItems.length > 0 ? this.handleClick : (function(){})}>
          <div className='cart__circle'>
            <span className='cart__tracks-count'>{cartItems.length}</span>
          </div>
          <span className='cart__symbol' title={this.props.i18n.shopping_cart}>
            <i className='fa fa-shopping-cart'></i>
          </span>
          <div className='cart__list-invisible'>
            {cartItems}
            <div className='cart-action text-center'>
              {submitButton}
            </div>
          </div>
        </div>
        {drawerMarkup}
      </div>
    )
  }
};

Cart.defaultProps = {
  data : [],
  subscribedUsageLicenseTypes: [],
  flatrateDownloadsToday: 0,
  flatrateDownloadLimit: 0,
  usage_license_types: [],
  i18n : {
    free: 'for free',
    checkout_now: 'Checkout now',
    shopping_cart: 'Shopping cart'
  }
}


// INIT

let elements = document.querySelectorAll('[data-react-component=Cart]');

elements.forEach(function(element) {
  try {
    let reactProps = parseReactProps(element.dataset.reactProps);

    ReactDOM.render(
      <React.StrictMode>
        <Cart {...reactProps} />
      </React.StrictMode>,
      element
    );
  } catch (error) {
    console.error('Failed to mount Cart', error);
  }
})

export default Cart;
